
import React, { Component } from 'react';
import YouTube from 'react-youtube';
// import logo from "../assets/femcc-01/logo.png";
// import ecopetrol from "../assets/femcc-01/campania-ecoptrol.jpeg";
import './videoplayer.css';

class VideoPlayer extends Component {

    constructor(props) {
        super(props);

        const videosIniciales = props.videos
            ? props.videos.split(",").map(v => v.trim()).filter(Boolean)
            : [];

        this.state = {
            windowWidth: window.innerWidth,
            videos: videosIniciales,
            currentVideo: 0,
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.videos !== this.props.videos) {
            const nuevosVideos = this.props.videos
                ? this.props.videos.split(",").map(v => v.trim()).filter(Boolean)
                : [];

            this.setState({
                videos: nuevosVideos,
                currentVideo: 0
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    };

    onEnd = () => {
        const { currentVideo, videos } = this.state;

        if (!videos.length) return;

        const nextVideo = (currentVideo + 1) % videos.length;

        this.setState({
            currentVideo: nextVideo
        });
    };

    _onReady = (event) => {
        event.target.mute(); // opcional: silenciar
        event.target.playVideo();
    };

    render() {
        const { windowWidth, videos, currentVideo } = this.state;

        if (!videos || videos.length === 0) {
            return (
                <div className="text-center p-4">
                    Cargando videos...
                </div>
            );
        }

        const videoWidth = windowWidth > 400
            ? windowWidth * 0.8
            : windowWidth;

        const videoOpts = {
            height: 300,
            width: videoWidth.toString(),
            playerVars: {
                autoplay: 1,
                loop: videos.length === 1 ? 1 : 0,
                playlist: videos[currentVideo],
                mute: 1,
                fs: 0,
                controls: 1,
                modestbranding: 1,
                rel: 0,
                disablekb: 1,
                iv_load_policy: 3,
                start: 0
            }
        };

        return (
            <div>
                <div className="video-container">
                    <div className="text-center video-player">
                        <YouTube
                            videoId={videos[currentVideo]}
                            opts={videoOpts}
                            onEnd={this.onEnd}
                            onReady={this._onReady}
                        />
                        
                    </div>
                </div>

                <div className="d-grid gap-2 mt-2 mb-2">
                    {/* Imagen opcional */}
                    {/* <img
                        className="d-block mx-auto"
                        style={{ height: '90%', width: '100%' }}
                        src={ecopetrol}
                        alt=""
                    /> */}
                </div>
            </div>
        );
    }
}

export default VideoPlayer;

